export default __webpack_public_path__ + "static/media/black01.bc9e4834.png";